mutation approveOrRejectUser($id: ID!, $userAccessStatusType: UserAccessStatusType!) {
  approveOrRejectUser(id: $id, userAccessStatusType: $userAccessStatusType)
}
